import { CheckName } from 'dashboard/models/check/check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';

export enum DocumentType {
  ABNSummary = 'abn_summary',
  AdditionalUtilityBill = 'additional_utility_bill',
  ArchivioDellaCCIAA = 'archivio_della_cciaa',
  ArticlesOfAssociation = 'articles_of_association',
  ArticlesOfIncorporation = 'articles_of_incorporation',
  AttestationDeCompte = 'attestation_de_compte',

  BankStatement = 'bank_statement',
  BankVoucher = 'bank_voucher',
  BirthCertificate = 'birth_certificate',
  BrokerageAccountStatement = 'brokerage_account_statement',
  BusinessConfirmationLetter = 'business_confirmation_letter',
  BusinessLicense = 'business_license',

  CentralRegisterAndInformationOnEconomicActivity = 'central_register_and_information_on_economic_activity',
  CertificateOfAuthorization = 'certificate_of_authorization',
  CertificateOfBusinessRegistration = 'certificate_of_business_registration',
  CertificateOfCitizenship = 'certificate_of_citizenship',
  CertificateOfGoodStanding = 'certificate_of_good_standing',
  CertificateOfNaturalization = 'certificate_of_naturalization',
  CertificateOfRegistrationForVat = 'certificate_of_registration_for_vat',
  CertificateOfResidence = 'certificate_of_residence',
  CertificateOfTaxResidence = 'certificate_of_tax_residence',
  CertificateOfValidity = 'certificate_of_validity',
  CertificateOfVATNumber = 'certificate_of_vat_number',
  CharitiesAndNotForProfitsCommissionExtract = 'charities_and_not_for_profits_commission_extract',
  CharityCommissionDocument = 'charity_commission_document',
  CharityRegistration = 'charity_registration',
  Check = 'check',
  CommercialLeaseAgreement = 'commercial_lease_agreement',
  CompanyExtract = 'company_extract',
  CompanyExtractExtended = 'company_extract_extended',
  CompanyExtractSummary = 'company_extract_summary',
  CompanyPrintout = 'company_printout',
  CompanyStatement = 'company_statement',
  ConstanciaDeSituacionFiscal = 'constancia_de_situacion_fiscal',
  ConsumerAffairsAssociationExtract = 'consumer_affairs_association_extract',
  CorporationInformation = 'corporation_information',
  CreditCardStatement = 'credit_card_statement',
  CurrentExtractInformation = 'current_extract_information',

  DdForm214 = 'dd_form_214',

  EnrollmentDocumentForIndividualEntrepreneur = 'enrollment_document_for_individual_entrepreneur',
  ExtractFromRegistryOfEntrepreneursAndNonEntrepreneurialLegalEntities = 'extract_from_registry_of_entrepreneurs_and_non_entrepreneurial_legal_entities',

  Form1040 = 'form_1040',
  Form1098 = 'form_1098',
  Form1098C = 'form_1098_c',
  Form1098E = 'form_1098_e',
  Form1098F = 'form_1098_f',
  Form1098Ma = 'form_1098_ma',
  Form1098Q = 'form_1098_q',
  Form1098T = 'form_1098_t',
  Form1099Consolidated = 'form_1099_consolidated',
  Form1099B = 'form_1099_b',
  Form1099Div = 'form_1099_div',
  Form1099Int = 'form_1099_int',
  Form1099K = 'form_1099_k',
  Form1099Misc = 'form_1099_misc',
  Form1099Nec = 'form_1099_nec',
  FormCt600 = 'form_ct_600',
  FormW2 = 'form_w2',
  FormW8BenE = 'form_w8_ben_e',
  FormW8Eci = 'form_w8_eci',
  FormW9 = 'form_w9',

  FunkcijuIzpildesDepartaments = 'funkciju_izpildes_departaments',

  HealthInsuranceCard = 'health_insurance_card',
  HomeownersInsuranceStatement = 'homeowners_insurance_statement',

  IndependentThirdPartyAmlAssessment = 'independent_third_party_aml_assessment',
  Invoice = 'invoice',
  Irs147cLetter = '147c_letter',
  IrsCp565Letter = 'cp565_letter',
  IrsCp575Letter = 'cp575_letter',

  LetterOfAuthorization = 'letter_of_authorization',
  LiabilityInsurance = 'liability_insurance',

  MeiCertificate = 'mei_certificate',

  NgbForm22 = 'ngb_form_22',
  NoticeOfAssessment = 'notice_of_assessment',

  Paystub = 'paystub',

  Receipt = 'receipt',
  RegistrationOfBusinessChangeOfName = 'registration_of_business_change_of_name',
  RegistrationOfBusinessName = 'registration_of_business_name',
  RegistrationCertificate = 'registration_certificate',
  RentersInsuranceStatement = 'renters_insurance_statement',
  ReportOfBirthAbroad = 'report_of_birth_abroad',
  ResidentialLeaseAgreement = 'residential_lease_agreement',

  SocialSecurityCardUnrestricted = 'social_security_card_unrestricted',
  SocialSecurityCardRestricted = 'social_security_card_restricted',
  SoleProfessionalLicense = 'sole_professional_license',
  StandardUtilityBill = 'standard_utility_bill',
  StatementOfAccount = 'statement_of_account',
  StudentIdCard = 'student_id_card',

  TaxAuthorityCertificate = 'tax_authority_certificate',
  TaxCertificate = 'tax_certificate',
  TrustAgreement = 'trust_agreement',

  UdyamRegistrationCertificate = 'udyam_registration_certificate',

  VehicleInsurance = 'vehicle_insurance',
  VehicleRegistration = 'vehicle_registration',
  VehicleTitle = 'vehicle_title',

  ZivnostenskyList = 'zivnostensky_list',

  // Classified without rule engine
  GovernmentId = 'government_id',

  // `other` is a proxy for failure to classify document
  Other = 'other',

  // LEGACY TYPES / TO BE DEPRECATED
  CorporateDocument = 'corporate_document',
  TaxDocument = 'tax_document',
}

export const DOCUMENT_TYPE_TO_DISPLAY_NAME: Record<string, string> = {
  [DocumentType.ABNSummary]: 'ABN Summary (Australia)',
  [DocumentType.AdditionalUtilityBill]: 'Additional Utility Bill',
  [DocumentType.ArchivioDellaCCIAA]: 'Archivio Ufficiale della CCIAA',
  [DocumentType.ArticlesOfAssociation]: 'Articles of Association (Brazil)',
  [DocumentType.ArticlesOfIncorporation]: 'Articles of Incorporation',
  [DocumentType.AttestationDeCompte]: 'Attestation de Compte (France)',

  [DocumentType.BankStatement]: 'Bank Statement',
  [DocumentType.BankVoucher]: 'Bank Voucher',
  [DocumentType.BirthCertificate]: 'Birth Certificate',
  [DocumentType.BrokerageAccountStatement]: 'Brokerage Account Statement',
  [DocumentType.BusinessConfirmationLetter]: 'Business Confirmation Letter (Canada)',
  [DocumentType.BusinessLicense]: 'Business License (Canada, China)',

  [DocumentType.CentralRegisterAndInformationOnEconomicActivity]:
    'Central Register And Information On Economic Activity (Poland)',
  [DocumentType.CertificateOfAuthorization]: 'Certificate of Authorization (China)',
  [DocumentType.CertificateOfBusinessRegistration]:
    'Certificate of Business Registration (Australia)',
  [DocumentType.CertificateOfCitizenship]: 'Certificate of Citizenship',
  [DocumentType.CertificateOfGoodStanding]: 'Certificate of Good Standing (US)',
  [DocumentType.CertificateOfNaturalization]: 'Certificate of Naturalization',
  [DocumentType.CertificateOfRegistrationForVat]: 'Certificate of Registration for VAT (UK)',
  [DocumentType.CertificateOfResidence]: 'Certificate of Residence (UK)',
  [DocumentType.CertificateOfTaxResidence]: 'Certificate of Tax Residence (Brazil)',
  [DocumentType.CertificateOfValidity]: 'Certificate of Validity (Chile)',
  [DocumentType.CertificateOfVATNumber]: 'Certificate of VAT Number (Italy)',
  [DocumentType.CharitiesAndNotForProfitsCommissionExtract]:
    'Charities and Not-for-Profits Commission Extract (Australia)',
  [DocumentType.CharityCommissionDocument]: 'Charity Commission Document (UK)',
  [DocumentType.CharityRegistration]: 'Charity Registration (UK)',
  [DocumentType.Check]: 'Check',
  [DocumentType.CommercialLeaseAgreement]: 'Commercial Lease Agreement',
  [DocumentType.CompanyExtract]: 'Company Extract (Australia)',
  [DocumentType.CompanyExtractExtended]: 'Company Extract Extended (Australia)',
  [DocumentType.CompanyExtractSummary]: 'Company Extract Summary (Australia)',
  [DocumentType.CompanyPrintout]: 'Company Printout (Ireland)',
  [DocumentType.CompanyStatement]: 'Company Statement (Australia)',
  [DocumentType.ConstanciaDeSituacionFiscal]: 'Constancia de Situación Fiscal (Mexico)',
  [DocumentType.ConsumerAffairsAssociationExtract]:
    'Consumer Affairs Association Extract (Australia)',
  [DocumentType.CorporationInformation]: 'Corporation Information (Canada)',
  [DocumentType.CreditCardStatement]: 'Credit Card Statement',
  [DocumentType.CurrentExtractInformation]: 'Current Extract Information (Poland)',

  [DocumentType.DdForm214]: 'DD Form 214',

  [DocumentType.EnrollmentDocumentForIndividualEntrepreneur]:
    'Enrollment Document for Individual Entrepreneur (Brazil)',

  [DocumentType.ExtractFromRegistryOfEntrepreneursAndNonEntrepreneurialLegalEntities]:
    'Extract From Registry Of Entrepreneurs And Non Entrepreneurial Legal Entities (Georgia)',
  [DocumentType.Form1040]: 'Form 1040',

  [DocumentType.Form1098]: 'Form 1098',
  [DocumentType.Form1098C]: 'Form 1098-C',
  [DocumentType.Form1098E]: 'Form 1098-E',
  [DocumentType.Form1098F]: 'Form 1098-F',
  [DocumentType.Form1098Ma]: 'Form 1098-MA',
  [DocumentType.Form1098Q]: 'Form 1098-Q',
  [DocumentType.Form1098T]: 'Form 1098-T',

  [DocumentType.Form1099Consolidated]: 'Form 1099-Consolidated',
  [DocumentType.Form1099B]: 'Form 1099-B',
  [DocumentType.Form1099Div]: 'Form 1099-DIV',
  [DocumentType.Form1099Int]: 'Form 1099-INT',
  [DocumentType.Form1099K]: 'Form 1099-K',
  [DocumentType.Form1099Misc]: 'Form 1099-MISC',
  [DocumentType.Form1099Nec]: 'Form 1099-NEC',
  [DocumentType.FormCt600]: 'Form CT600',
  [DocumentType.FormW2]: 'Form W-2',
  [DocumentType.FormW8BenE]: 'Form W-8 BEN-E',
  [DocumentType.FormW8Eci]: 'Form W-8 ECI',
  [DocumentType.FormW9]: 'Form W-9',

  [DocumentType.FunkcijuIzpildesDepartaments]: 'Funkciju Izpildes Departaments (Latvia)',

  [DocumentType.HealthInsuranceCard]: 'Health Insurance Card',
  [DocumentType.HomeownersInsuranceStatement]: "Homeowner's Insurance Statement",

  [DocumentType.IndependentThirdPartyAmlAssessment]: 'Independent Third Party AML Assessment',
  [DocumentType.Invoice]: 'Invoice',
  [DocumentType.Irs147cLetter]: '147C Letter',
  [DocumentType.IrsCp565Letter]: 'CP565 Letter',
  [DocumentType.IrsCp575Letter]: 'CP575 Letter',

  [DocumentType.LetterOfAuthorization]: 'Letter of Authorization',
  [DocumentType.LiabilityInsurance]: 'Liability Insurance',

  [DocumentType.MeiCertificate]: 'MEI Certificate',

  [DocumentType.NgbForm22]: 'NGB Form 22',
  [DocumentType.NoticeOfAssessment]: 'Notice of Assessment (Canada)',

  [DocumentType.Paystub]: 'Paystub',

  [DocumentType.Receipt]: 'Business Receipt',
  [DocumentType.RegistrationOfBusinessChangeOfName]:
    'Registration of Business Change of Name (Australia)',
  [DocumentType.RegistrationOfBusinessName]: 'Registration of Business Name (Australia)',
  [DocumentType.RegistrationCertificate]: 'Registration Certificate (South Africa)',
  [DocumentType.RentersInsuranceStatement]: "Renter's Insurance Statement",
  [DocumentType.ReportOfBirthAbroad]: 'Report of Birth Abroad',
  [DocumentType.ResidentialLeaseAgreement]: 'Residential Lease Agreement',

  [DocumentType.SocialSecurityCardUnrestricted]: 'Social Security Card (Unrestricted)',
  [DocumentType.SocialSecurityCardRestricted]: 'Social Security Card (Restricted)',
  [DocumentType.SoleProfessionalLicense]: 'Sole Professional License (UAE)',
  [DocumentType.StandardUtilityBill]: 'Standard Utility Bill',
  [DocumentType.StatementOfAccount]: 'Statement Of Account (South Africa)',
  [DocumentType.StudentIdCard]: 'Student ID Card',

  [DocumentType.TaxAuthorityCertificate]: 'Tax Authority Certificate (Brazil)',
  [DocumentType.TaxCertificate]: 'Tax Certificate (Turkey)',
  [DocumentType.TrustAgreement]: 'Trust Agreement',

  [DocumentType.UdyamRegistrationCertificate]: 'Udyam Registration Certificate (India)',

  [DocumentType.VehicleInsurance]: 'Vehicle Insurance',
  [DocumentType.VehicleRegistration]: 'Vehicle Registration',
  [DocumentType.VehicleTitle]: 'Vehicle Title',

  [DocumentType.ZivnostenskyList]: 'Zivnostensky List (Czech Republic)',

  [DocumentType.GovernmentId]: 'Government Id',

  [DocumentType.Other]: 'Other',

  // LEGACY TYPES / TO BE DEPRECATED
  [DocumentType.CorporateDocument]: 'Corporate Document (DEPRECATED)',
  [DocumentType.TaxDocument]: 'Tax Document (DEPRECATED)',
};

export const V1_DOCUMENT_TYPES: DocumentType[] = [
  DocumentType.Check,
  DocumentType.Invoice,
  DocumentType.Paystub,
  DocumentType.SocialSecurityCardUnrestricted,
  DocumentType.SocialSecurityCardRestricted,
  DocumentType.CorporateDocument,
  DocumentType.TaxDocument,
];

export type TypeDetectionCriteria = {
  'type-name': string;
  'specified-languages': string[];
};

export type DocumentTypeCheckName = CheckName.DocumentTypeDetection;

export interface DocumentTypeCheckConfig extends VerificationCheckConfig {
  check: DocumentTypeCheckName;
  'type-acceptance-criteria': TypeDetectionCriteria[];
  'type-rejection-criteria': TypeDetectionCriteria[];
  'accepted-document-types': DocumentType[];
}

export function isDocumentTypeCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is DocumentTypeCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.DocumentTypeDetection:
      return true;
    default:
      return false;
  }
}
